import { render, staticRenderFns } from "./ItirazinIptaliDavasiInfo.vue?vue&type=template&id=1d68f5c9"
import script from "./ItirazinIptaliDavasiInfo.vue?vue&type=script&lang=ts"
export * from "./ItirazinIptaliDavasiInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports